(() => {
	angular.module('main').directive('btnAddSignature', btnAddSignature);

	function btnAddSignature() {
		return {
			restrict: 'E',
			scope: {
				title: '@'
			},
			template: `
                <button class="btn-lg btn btn-default add-signature-btn">
                    <i class="fa fa-plus" aria-hidden="true"></i>{{title}}
                </button>
`,
			replace: true,
			transclude: true,
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnAddSignature.js